/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Contactusdescription2Inputs */

const en_help_contactusdescription2 = /** @type {(inputs: Help_Contactusdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our team is here to help`)
};

/**
* | output |
* | --- |
* | "Our team is here to help" |
*
* @param {Help_Contactusdescription2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const help_contactusdescription2 = /** @type {((inputs?: Help_Contactusdescription2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Contactusdescription2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_contactusdescription2(inputs)
});
export { help_contactusdescription2 as "help_contactUsDescription" }